import { map, Observable } from "rxjs";
import { GetScenariaResponse } from "../request-response/get-scenaria-response";
import AxiosService from "./axios-service";
import { ScenarioModel } from "../models/scenario-model";
import { PollutantModel } from "../models/pollutant-model";
import { AnalysisModel } from "../models/analysis-model";
import { AxiosResponse } from "axios";
import { GetUsersResponse } from "../request-response/get-users-response";
import { UserModel } from "../models/user-model";

class UsersService {    
    private static instance: UsersService | null = null;

    private constructor() {
    }

    public static getInstance(): UsersService {
        if (this.instance === null) {
            this.instance = new UsersService();
        }
        return this.instance;
    }

    getUsers(page:number, pageSize:number):Observable<GetUsersResponse> {
        return AxiosService.getInstance().get(`/api/users?page=${page}&per_page=${pageSize}`);
    }

    getUser(id:string):Observable<UserModel> {
        return AxiosService.getInstance().get(`/api/users/${id}`);
    }

    createUser(name:string, email:string, password:string, roles:string[]):Observable<UserModel> {
        return AxiosService.getInstance().post<AxiosResponse>(`/api/users`, { name, email, password, roles}).pipe(map(response=>response.data));
    }

    updateUser(id:number, name:string, password:string, roles:string[]):Observable<UserModel> {
        return AxiosService.getInstance().put<AxiosResponse>(`/api/users/${id}`, { name, password, roles}).pipe(map(response=>response.data));
    }

    deleteUser(id:number):Observable<void> {
        return AxiosService.getInstance().delete<AxiosResponse>(`/api/users/${id}`).pipe(map(response=>response.data));
    }

    
}

export default UsersService;